import { Plugin } from 'ckeditor5'
import { SuggestionData, TrackChanges } from 'ckeditor5-premium-features'

export class TrackChangePlugin extends Plugin {
    static requires = ['TrackChanges', 'UserPlugin']
    static pluginName = 'TrackChangePlugin'

    init = () => {
        const trackChangesPlugin = this.editor.plugins.get(
            'TrackChanges'
        ) as TrackChanges

        // Load the initial suggestions from the config.
        // We have to do it this way since there's no prop to pass in for initial suggestions,
        // unlike initialData.
        const initialSuggestions = this.editor.config.get(
            'suggestions'
        ) as SuggestionData[]

        if (!initialSuggestions?.length) {
            return
        }

        initialSuggestions.forEach((suggestion) => {
            trackChangesPlugin.addSuggestion(suggestion)
        })
    }
}
